import React, { Fragment } from "react";
import { any, string, bool } from "prop-types";
import * as style from "./styles.module.scss";

export const FeedbackFaceTypes = Object.freeze({
  Sad: 1,
  Indifferent: 2,
  Happy: 3,
});

export const FaceColors = Object.freeze({
  NotPicked: 1,
  Normal: 2,
  Picked: 3,
});

const SadFaceFeatures = ({ isPicked }) => (
  <Fragment>
    <svg
      width="23"
      height="7"
      viewBox="0 0 23 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${style.feedback__sad} ${
        isPicked && style.feedback__sad_picked
      }`}
    >
      <path
        d="M2.33337 5C4.84061 3.11627 7.95736 2 11.3348 2C14.7123 2 17.8291 3.11627 20.3363 5"
        stroke="#495057"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
    <svg
      className={`${style.feedback__sadhover} ${
        isPicked && style.feedback__sadhover_picked
      }`}
      width="24"
      height="9"
      viewBox="0 0 24 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C8.95456 4 6.00157 5.50324 3.49611 8.3273C2.76306 9.15357 1.49898 9.22913 0.67272 8.49608C-0.153545 7.76304 -0.229111 6.49896 0.503938 5.6727C3.5692 2.21765 7.54121 0 12 0C16.4588 0 20.4308 2.21765 23.4961 5.6727C24.2292 6.49896 24.1536 7.76304 23.3273 8.49608C22.5011 9.22913 21.237 9.15357 20.5039 8.3273C17.9985 5.50324 15.0455 4 12 4Z"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
    <svg
      className={`${style.feedback__sadhover_eyebrowleft} ${
        isPicked && style.feedback__sadhover_eyebrowleft_picked
      }`}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.577403 4.31207C0.343998 3.81153 0.560553 3.21655 1.06109 2.98314L6.15071 0.609815C6.65125 0.376409 7.24623 0.592965 7.47964 1.0935C7.71304 1.59404 7.49649 2.18903 6.99595 2.42243L1.90633 4.79576C1.40579 5.02916 0.810809 4.81261 0.577403 4.31207Z"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
    <svg
      className={`${style.feedback__sadhover_eyebrowright} ${
        isPicked && style.feedback__sadhover_eyebrowright_picked
      }`}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.577403 0.906192C0.343998 1.40673 0.560553 2.00171 1.06109 2.23512L6.15071 4.60845C6.65125 4.84185 7.24623 4.6253 7.47964 4.12476C7.71304 3.62422 7.49649 3.02924 6.99595 2.79583L1.90633 0.422503C1.40579 0.189097 0.810809 0.405652 0.577403 0.906192Z"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
  </Fragment>
);

SadFaceFeatures.propTypes = {
  isPicked: bool,
};

const IndifferentFaceFeatures = ({ isPicked }) => (
  <span
    className={`${style.feedback__indifferent} ${
      isPicked && style.feedback__indifferent_picked
    }`}
  ></span>
);

IndifferentFaceFeatures.propTypes = {
  isPicked: bool,
};

const HappyFaceFeatures = ({ isPicked }) => (
  <Fragment>
    <svg
      width="23"
      height="7"
      viewBox="0 0 23 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${style.feedback__happy} ${
        isPicked && style.feedback__happy_picked
      }`}
    >
      <path
        d="M2.33337 5C4.84061 3.11627 7.95736 2 11.3348 2C14.7123 2 17.8291 3.11627 20.3363 5"
        stroke="#495057"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
    <span
      className={`${isPicked && style.feedback__happyhover_picked} ${
        style.feedback__happyhover
      }`}
    ></span>
  </Fragment>
);

HappyFaceFeatures.propTypes = {
  isPicked: bool,
};

const FeedbackFace = ({
  type = FeedbackFaceTypes.Indifferent,
  className = "",
  isPicked,
}) => (
  <span className={style.feedback__wrapper}>
    <svg
      className={`${style.feedback__face} ${className} ${
        isPicked && style.feedback__face_picked
      }`}
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.655 0.666687C10.7634 0.666687 0.333374 11.1084 0.333374 24C0.333374 36.8917 10.7634 47.3334 23.655 47.3334C36.5467 47.3334 47 36.8917 47 24C47 11.1084 36.5467 0.666687 23.655 0.666687ZM23.6667 42.6667C13.3534 42.6667 5.00004 34.3134 5.00004 24C5.00004 13.6867 13.3534 5.33335 23.6667 5.33335C33.98 5.33335 42.3334 13.6867 42.3334 24C42.3334 34.3134 33.98 42.6667 23.6667 42.6667ZM31.8334 21.6667C33.77 21.6667 35.3334 20.1034 35.3334 18.1667C35.3334 16.23 33.77 14.6667 31.8334 14.6667C29.8967 14.6667 28.3334 16.23 28.3334 18.1667C28.3334 20.1034 29.8967 21.6667 31.8334 21.6667ZM15.5 21.6667C17.4367 21.6667 19 20.1034 19 18.1667C19 16.23 17.4367 14.6667 15.5 14.6667C13.5634 14.6667 12 16.23 12 18.1667C12 20.1034 13.5634 21.6667 15.5 21.6667Z"
        fill={isPicked ? "#F96400" : "#495057"}
      />
    </svg>
    {type === FeedbackFaceTypes.Sad && <SadFaceFeatures isPicked={isPicked} />}
    {type === FeedbackFaceTypes.Indifferent && (
      <IndifferentFaceFeatures isPicked={isPicked} />
    )}
    {type === FeedbackFaceTypes.Happy && (
      <HappyFaceFeatures isPicked={isPicked} />
    )}
  </span>
);

FeedbackFace.propTypes = {
  type: any,
  className: string,
  isPicked: bool,
};

export default FeedbackFace;
